import ApiArticles from "../../../../api/articles";

// LF360-2017: /pages is paginated (20 per page by default), so a single call
// hid every active article past the 20 most recently updated ones from the
// picker and made the validator flag them as deleted. Walk all pages.
const ARTICLES_PAGE_SIZE = 100;

const getAllActiveArticlePages = async (query = {}) => {
  const pages = [];
  for (let page = 1; ; page += 1) {
    const response = await ApiArticles.get({ ...query, status: 'active', page, limit: ARTICLES_PAGE_SIZE });
    pages.push(...response.data.pages);
    if (!response.data.hasMore) {
      return pages;
    }
  }
};

export { getAllActiveArticlePages };
